import { Component, EventEmitter, Output } from '@angular/core';
import { filter, map, tap } from 'rxjs/operators';
import { BaseComponent } from '../../../../shared/base-components/base.component';
import { OmnisearchModel } from '../../../../shared/models/search/omnisearch.model';
import { VehiclePermitType } from '../../../../vehicle/models/enums/vehicle-permit-type.enum';
import { VehiclePermitModel } from '../../../../vehicle/models/vehicle-permit.model';
import { VehicleModel } from '../../../../vehicle/models/vehicle.model';
import { VehiclePermitService } from '../../../../vehicle/services/vehicle-permit.service';

@Component({
    selector: 'permit-search',
    templateUrl: './permit-search.html',
})
export class PermitSearchComponent extends BaseComponent {
    @Output() onVehicleSelected: EventEmitter<OmnisearchModel> = new EventEmitter<OmnisearchModel>();

    public hasSearched = false;
    public permitSearchString: string;
    public permitTypes = new VehiclePermitType().GetAll();
    public results: VehiclePermitModel[] = [];

    constructor(private vehiclePermitService: VehiclePermitService) {
        super();
    }

    public ngOnInit() {}

    public onPermitNumberClicked(selectedVehicle: VehicleModel) {
        this.onVehicleSelected.emit(this.mapVehicleModelToOmnisearchModel(selectedVehicle));
    }

    public permitSearchClicked = (): void => {
        this.vehiclePermitService.getPermitsByContainingPermitNumber(this.permitSearchString)
            .pipe(
                tap((results: VehiclePermitModel[]) => {
                    this.results = results;
                    this.hasSearched = true;
                }),
                filter(results => Array.isArray(results) && results.length === 1),
                map(results => results[0]),
                filter(vehiclePermit => !!vehiclePermit && !!vehiclePermit.vehicle)
            )
            .subscribe(
                vehiclePermit => this.onVehicleSelected.emit(this.mapVehicleModelToOmnisearchModel(vehiclePermit.vehicle)),
                err => console.log(err)
            );
    };

    public resetSearch() {
        this.results = [];
        this.permitSearchString = null;
        this.hasSearched = false;
    }

    private mapVehicleModelToOmnisearchModel(genResult: VehicleModel) {
        const result = new OmnisearchModel();
        result.bodyStyleTypeDisplayValue = genResult.bodyStyleTypeDisplayValue;
        result.makeDisplayValue = genResult.makeDisplayValue;
        result.modelDisplayValue = genResult.modelDisplayValue;
        result.modelYear = genResult.modelYear;
        result.vehicleId = genResult.id;
        result.vehicleNumber = genResult.vehicleNumber;
        result.vin = genResult.vin;
        return result;
    }
}
